import styled from 'styled-components';

const Body = styled.div`
  padding: 10px;
`;

Body.displayName = 'Body';

export default Body;
